import { SeededRandom } from '@utils/SeededRandom';

export interface Star {
  x: number; // 0..1, normalised to viewport width
  y: number; // 0..1, normalised to viewport height
  layer: 0 | 1 | 2; // 0 = far, 2 = near
  size: number;
  brightness: number; // 0..1
  twinkleSpeed: number;
  twinklePhase: number;
  color: string;
}

export interface Nebula {
  x: number;
  y: number;
  radius: number; // relative to the larger viewport dimension
  color: [number, number, number];
  alpha: number;
}

const STAR_COLORS = ['#ffffff', '#cfe4ff', '#fff2d6', '#ffd9d9', '#d6f0ff'];
const NEBULA_COLORS: [number, number, number][] = [
  [80, 40, 160], [20, 90, 160], [150, 30, 90], [20, 120, 110]
];

export function generateStarfield(seed: number, count: number): Star[] {
  const rng = new SeededRandom(seed);
  return Array.from({ length: count }, () => {
    const layerRoll = rng.next();
    const layer: 0 | 1 | 2 = layerRoll < 0.6 ? 0 : layerRoll < 0.9 ? 1 : 2;
    return {
      x: Math.min(rng.next(), 0.999999),
      y: Math.min(rng.next(), 0.999999),
      layer,
      size: (0.4 + rng.next() * 0.5) * (1 + layer * 0.7),
      brightness: 0.3 + rng.next() * 0.7,
      twinkleSpeed: 0.001 + rng.next() * 0.003,
      twinklePhase: rng.next() * Math.PI * 2,
      color: rng.choose(STAR_COLORS),
    };
  });
}

export function generateNebulae(seed: number, count: number): Nebula[] {
  const rng = new SeededRandom(seed);
  return Array.from({ length: count }, () => ({
    x: rng.next(),
    y: rng.next(),
    radius: 0.25 + rng.next() * 0.35,
    color: rng.choose(NEBULA_COLORS),
    alpha: 0.05 + rng.next() * 0.07,
  }));
}
